/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [SSO, setSSO] = useState([])
  const [superadmin_apps, setsuperadmin_apps] = useState([])
  const [loader, setloader] = useState(true)

  const getAppCompanies = async () => {
    const { response } = await AppService.appinstalls.getapplogs()
    // console.log(response, 'getAppCompanies')
    if (response) {
      setList(response.data)
      // setSSO(response.SSO)
      setsuperadmin_apps(response.superadmin_apps)
      setloader(false)
    } else {
      setList([])
      setloader(false)
    }
  }
  const onLoad = () => {
    getAppCompanies()
  }
  useEffect(onLoad, [])
  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'App_Name', accessor: 'App_Name' },
        { Header: 'app_id', accessor: 'app_id' },
        { Header: 'action', accessor: 'action' },
        { Header: 'Location Id', accessor: 'LocationId' },
        { Header: 'Company Id', accessor: 'CompanyId' },
        { Header: 'createdAt', accessor: 'createdAt' },
      ],

      rows: List.map((data) => {
        return {
          App_Name: superadmin_apps.filter(
            (app) => app.app_id == data.app_id || app.free_app?.app_id == data.app_id
          )[0]?.name,
          app_id: data.app_id,
          action: data.action,
          LocationId: data.locationId,
          CompanyId: data.companyId,
          createdAt: data.createdAt,
        }
      }),
    },
  }
}
